// extracted by mini-css-extract-plugin
export default {"control":"AddMovie_control__Jzo4g","button":"AddMovie_button__JKJPX"};